import { render, staticRenderFns } from "./faultmanagement.vue?vue&type=template&id=a024487e&scoped=true"
import script from "./faultmanagement.vue?vue&type=script&lang=js"
export * from "./faultmanagement.vue?vue&type=script&lang=js"
import style0 from "./faultmanagement.vue?vue&type=style&index=0&id=a024487e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a024487e",
  null
  
)

export default component.exports